import React from 'react'
import { Card, CardContent, CardFooter } from '@components/layout/Card'
import styles from './user-details-card.module.sass'
import PropTypes from 'prop-types'

export const UserDetailsCard = ({ user, canEdit }) => {
  return (
    <Card className={styles.userDetailsCard}>
      <CardContent>
        <div className={styles.profileDetails}>
          <div className={styles.profileItem}>
            <h2>Preferred Name</h2>
            <p>{user.personalName}</p>
          </div>
          <div className={styles.profileItem}>
            <h2>Email Address</h2>
            <p>{user.email}</p>
          </div>
          <div className={styles.profileItem}>
            <h2>Contact Number</h2>
            <p>{user.cellphoneNumber}</p>
          </div>
          <div className={styles.profileItem}>
            <h2>Birthday</h2>
            <p>{user.birthday}</p>
          </div>
        </div>
      </CardContent>
      { canEdit && (
        <CardFooter>
          <a href={`/clients/${user.id}/edit`}>
            Edit Profile
          </a>
        </CardFooter>
      )}
    </Card>
  )
}

UserDetailsCard.propTypes = {
  user: PropTypes.object.isRequired,
}
